import { Card, Table } from 'react-bootstrap';

const ReferalDetails = ({ data }) => {
    if (!data) {
        return "";
    }

    return (
        <Card className='mb-4'>
            <Card.Body>
                <h6>Referal Details</h6>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Client Name</th>
                            {/* <th>Client Email</th> */}
                            <th>Client Phone</th>
                            <th>Referal Type</th>
                            <th>Client Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{`${data?.client_name} ${data?.client_lastname}`}</td>
                            {/* <td>
                                {data?.client_email}
                            </td> */}
                            <td>
                                {data?.client_phone}
                            </td>
                            <td>{data?.referral_type ? data?.referral_type.toUpperCase() : "SELLER"}</td>
                            <td>{data?.street_address}</td>
                        </tr>
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    )
}

export default ReferalDetails